import {CustodianService, LatestCustodianLoadDate, GetUsaStateTaxOptions} from '@simpleinvest/ms-custodian-sdk';
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';

interface GetBankLinkIdentityRequestsOptions {
  clUserId: string;
  bankAccountId: string;
}

export default {
  getCustodianServiceInstance({logger = getLogger()} = {}): CustodianService {
    return new CustodianService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger,
    });
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getBankLinkIdentityRequests(options: GetBankLinkIdentityRequestsOptions): Promise<any> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.getBankAccountIdentityRequestsForClUser(options);
  },

  async latestCustodianLoadDate(): Promise<LatestCustodianLoadDate[]> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.getLatestCustodianLoadDate({});
  },

  async getUsaStateTaxRules(options: GetUsaStateTaxOptions): Promise<unknown> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.getUsaStateTaxRules(options);
  },
};
